/* eslint-disable @nx/enforce-module-boundaries */
import { useEffect, useState } from 'react';
import { Config, EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { Modal } from '@marriott/mi-ui-library';
import { MerchandisingModalComp } from '@marriott/mi-merch-components';
import { StyledPropertyPortalWrapper } from './PropertyPortalWrapper.styles';

export function PropertyPortalWrapper(props: Record<string, unknown>) {
  // const showModel = props?.['isAuthorMode'] ? false : true;
  // Instead of showing model on page load, will keep it false and open it once either MerchandisingModalComp has either dca content or evergreen content
  // otherwise in one use case it will create performance issues as the model will be shown on page load and then closed when the there is no content
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // document.querySelector('body')?.classList.add('mdc-dialog-scroll-lock');
      document.body.style.overflow = 'hidden';
    } else {
      // document.querySelector('body')?.classList.remove('mdc-dialog-scroll-lock');
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  return (
    <StyledPropertyPortalWrapper className="portal-modal-component my-4 py-2">
      <Modal
        show={isOpen}
        onClose={() => setIsOpen(false)}
        secondaryClassName="d-flex justify-content-center align-items-center"
        role="region"
      >
        <MerchandisingModalComp
          {...({
            ...props,
            onCloseButtonClick: () => setIsOpen(false),
            setIsOpen: props?.['isAuthorMode'] ? () => {} : setIsOpen,
          } as Record<string, unknown>)}
        />
      </Modal>
    </StyledPropertyPortalWrapper>
  );
}

export const PropertyPortalWrapperConfig = {
  emptyLabel: 'PropertyPortalWrapper',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `mi-aem-common-spa/components/content/modal`,
} as Config<MappedComponentProperties>;

export const PropertyPortalWrapperEditable = (props: Record<string, unknown>) => (
  <EditableComponent config={PropertyPortalWrapperConfig} {...props}>
    <PropertyPortalWrapper {...props} />
  </EditableComponent>
);
